// Play page firebase analytics (exported for SimpleVersion). Rendering is handled
// by the master app via PlayPage; no ReactDOM.render here.
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAZfuQEXpNY5mScwvyrEt7WFkwbeUgcRUg',
  authDomain: 'leta-modelling-energy.firebaseapp.com',
  projectId: 'leta-modelling-energy',
  storageBucket: 'leta-modelling-energy.appspot.com',
  messagingSenderId: '665567648507',
  appId: '1:665567648507:web:088c4f4e214e885c9eae5e',
  measurementId: 'G-QNVNRRMSSS',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
